import { Navigate, Route, Routes } from 'react-router-dom'
import { useConfig } from 'builder/hooks/useConfig'
import { ConfigScopesEnum } from 'builder/modules/init'
import { CustomInterviewView } from './view/CustomInterviewView/CustomInterviewView'
import { InterviewDashboardView } from './view/DashboardView/DashboardView'
import { InterviewPlayerView } from './view/InterviewPlayerView/InterviewPlayerView'
import { QuestionsLibraryView } from './view/QuestionsLibraryView/QuestionsLibraryView'
import { FeedbackView } from './view/FeedbackView/FeedbackView'
import { CheckYourInboxView } from './view/CheckYourInboxView/CheckYourInboxView'
import { ReadyToStartView } from './view/ReadyToStartView/ReadyToStartView'
import { LoggedUserStartView } from './view/InterviewStartView/LoggedUserStartView'
import { UnloggedUserStartView } from './view/InterviewStartView/UnloggedUserStartView'

export const InterviewStartRoutesView = () => {
  const config = useConfig(ConfigScopesEnum.signUp)
  if (!config?.features.interviewSchool) {
    return <Navigate to="/" />
  }
  return (
    <Routes>
      <Route path="" element={<UnloggedUserStartView />} />
      <Route path=":behaviour" element={<UnloggedUserStartView />} />
      <Route path="/page/check-your-inbox" element={<CheckYourInboxView />} />
    </Routes>
  )
}

export const InterviewPreparationRoutesView = () => {
  return (
    <Routes>
      <Route path="new" element={<LoggedUserStartView />} />
      <Route path="new/:behaviour" element={<LoggedUserStartView />} />
      <Route path="ready" element={<ReadyToStartView />} />
      <Route path="interview-player" element={<InterviewPlayerView />} />
      <Route path="dashboard" element={<InterviewDashboardView />} />
      <Route path="questions-library" element={<QuestionsLibraryView />} />
      <Route path="feedback" element={<FeedbackView />} />
      <Route path="custom-interview" element={<CustomInterviewView />} />
    </Routes>
  )
}
